import classes from './styles.module.css';
import { TFunction } from 'i18next';



function Footer(props: { t: TFunction, lang: string }) {
    return (
        <section className={classes.copyright__footer}>
            <div className='container'>
                <div className={classes.copyright}>
                    <div>
                        {props.t("footer.copyright")}
                    </div>

                </div>
            </div>


        </section>
    )
}

export default Footer